import "../css/mycompanies.css";
import "../css/button.css";
import buttoncss from "../css/button.module.css";
import commoncss from "../css/common.module.css";
import companyCss from "../css/company.module.css";

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Button } from "../elements/Button";
import Tabs from "../elements/Tabs";
import InputGroup from "../elements/InputGroup";
import Dropdown from "../elements/Dropdown";
import ToggleButton from "../elements/ToggleButton";
import erps from "../data/erps.json";
import AddERPConfigModal from "./../components/mycompanies/AddERPConfigModal";
import SuccessModal from "../components/connections/SuccessModal";
import ErrorModal from "../components/connections/ErrorModal";
import { headers } from "../../Bookclosure/Services/ApiHandler";
import Breadcrumb from "./../components/Breadcrumb";
import CompanyEditSideMenu from "../components/companyedit/CompanyEditSideMenu";
import { ReactComponent as ERPLink } from "../assets/icons/erpLink.svg";
import { ReactComponent as PlusIcon } from "../assets/icons/plus.svg";

export default function MyCompanies() {
  const { companyId } = useParams();

  const domain = window.appConfig.backend_domain;

  const user = JSON.parse(localStorage.getItem("user"));

  const userid = user._id;

  const [companies, setCompanies] = useState([]);
  const [companyInfo, setCompanyInfo] = useState(null);
  const [erpConnectionInfo, setErpConnectionInfo] = useState(null);
  const [companyErp, setCompanyErp] = useState(null);
  const [addERPModal, setAddERPModal] = useState(false);
  const [displayModal, setDisplayModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [linkErpBtn, setLinkErpBtn] = useState(false);
  const [companyId_, setCompanyId] = useState(null);
  const [activeTab, setActiveTab] = useState(null);
  const [erpLinkId, setErpLinkId] = useState(null);
  const [linkStatus, setLinkStatus] = useState({
    msbc: false,
    tally_prime: false,
  });
  const [selectedERP, setSelectedERP] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const [selectedCompanyName, setSelectedCompanyName] = useState(null);
  const [connectionType, setConnectionType] = useState(null);
  const [oAuthUrl, setOAuthUrl] = useState(null);
  const [apiBaseUrl, setApiBaseUrl] = useState(null);
  const [clientId, setClientId] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);
  const [showSecret, setShowSecret] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [grantType, setGrantType] = useState(null);
  const [scope, setScope] = useState(null);
  const [tentId, setTentId] = useState(null);
  const [erpCompany, setErpCompany] = useState(null);
  const [erpTabs, setErpTabs] = useState([]);
  const [companyID, setCompanyID] = useState(companyId); // company ID

  // const breadcrumbItems = [
  //   {
  //     label: "My Companies",
  //     link: "/myfinv2/my-companies",
  //     className: `${commoncss.nav_cnt_color} clickable`,
  //   },
  //   { label: "ERP Linking", link: "", className: "headerLable" },
  // ];

  // const [breadCompanyName, setbreadCompanyName] = useState('');  // company name

    const breadcrumbItems = [
        {
            label: "My companies",
            link: `/myfinV2/my-companies`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: selectedCompanyName,
            link: `/myfinV2/company-details/${companyID}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        { 
          label: "ERP Linking",
          link: "", 
          className: "headerLable" 
        },
    ];

  useEffect(() => {
    if (companyId) {
      showERPConnections(companyId);
    }
  }, [companyId]);

  useEffect(() => {
    if (selectedERP === "DynamicBC") {
      setErpTabs(["MSBC"]);
      setActiveTab("MSBC");
    }
    if (selectedERP === "tallyPrime") {
      setErpTabs(["Tally Prime"]);
      setActiveTab("Tally Prime");
    }
    if (selectedERP === "erpnext") {
      setErpTabs(["ERPNext"]);
      setActiveTab("ERPNext");
    }
  }, [selectedERP]);
  const handleClose = () => {
    setDisplayModal(false);
  };

  // let tabs = ["MSBC", "Tally Prime", "Tally9"];
  const showERPConnections = () => {
    const payload = { companyId: companyId };
    axios
      .post(domain + "/api/v1/erp/get-erp-companyconfig", payload, { headers })
      .then((resp) => {
        if (resp.data.statusCode === 0) {
          const erpConfig = resp.data.erpConfig;
          if (erpConfig) {
            if (erpConfig.erp === "tallyPrime") {
              setActiveTab(["Tally Prime"]);
              setErpTabs(["Tally Prime"]);
              setCompanyErp("tallyPrime");
            } else if (erpConfig.erp === "DynamicBC") {
              setActiveTab(["MSBC"]);
              setErpTabs(["MSBC"]);
              setCompanyErp("DynamicBC");
            } else if (erpConfig.erp === "erpnext") {
              setActiveTab(["ERPNext"]);
              setErpTabs(["ERPNext"]);
              setCompanyErp("erpnext");
            }
            setLinkErpBtn(false);

            const isActive = erpConfig.status === "A";

            setLinkStatus((prev) => ({
              ...prev,
              [erpConfig.erp || erpConfig.companyErp]: isActive,
            }));

            setErpLinkId(erpConfig._id);
            setSelectedERP(erpConfig.erp);
            setCompanyName(erpConfig.company);
            setSelectedCompanyName(resp.data.company_name);
            setConnectionType(erpConfig.connection_type);
            setOAuthUrl(erpConfig.OauthUrl);
            setApiBaseUrl(erpConfig.api_url_base_path);
            setClientId(erpConfig.client_id);
            setClientSecret(erpConfig.client_secret);
            setGrantType(erpConfig.grant_type);
            setScope(erpConfig.scope);
            setTentId(erpConfig.tentId);
            setErpCompany(erpConfig.erp_company || "");
            setCompanyId(erpConfig.companyId);
          } else {
            setLinkErpBtn(true);
            setSelectedCompanyName(resp.data.company_name);
          }
        }
      })
      .catch((error) => {
        console.error("Error in getting ERP Config:", error);
      });
    setCompanyErp(null);
    setErpConnectionInfo(companyId);
    // }
  };

  const erpConfigData = (erpData) => {
    erpData["userId"] = userid;
    erpData["companyId"] = companyId;
    erpData["status"] = "A";

    const payload = erpData;
    axios
      .post(domain + "/api/v1/erp/add-erp-companyconfig", payload, { headers })
      .then((resp) => {
        if (resp.data.statusCode === 0) {
          setSuccessMessage(`ERP Linked Successfully`);
          setDisplayModal(true);
          setSuccessModal(true);
          showERPConnections(companyId);
          setErpConnectionInfo(companyId);
        } else {
          setErrorMessage(resp.data.message);
          setDisplayModal(true);
          setErrorModal(true);
          // showERPConnections(companyInfo);
          // setErpConnectionInfo(false);
          setLinkStatus({ msbc: false, tally_prime: false });
        }
      })
      .catch((error) => {
        console.error("Error in linking ERP:", error);
      });
  };

  const handleLinkStatus = (newState, id) => {
    setLinkStatus((prev) => ({
      ...prev,
      [id]: newState,
    }));
    console.log(`Toggle ${id} is now ${newState ? "ON" : "OFF"}`);
  };
  const updateErpConfigData = () => {
    const status = linkStatus[selectedERP] || false;

    let erpData;
    if (selectedERP === "erpnext") {
      let normalizedSiteUrl = apiBaseUrl ? apiBaseUrl.trim() : "";
      try {
        if (normalizedSiteUrl) {
          const urlObj = new URL(
            normalizedSiteUrl.startsWith("http://") || normalizedSiteUrl.startsWith("https://")
              ? normalizedSiteUrl
              : `https://${normalizedSiteUrl}`
          );
          normalizedSiteUrl = urlObj.origin;
        }
      } catch (e) {}

      erpData = {
        erpLinkId: erpLinkId,
        erp: "erpnext",
        connection_type: "token",
        companyId: companyId,
        company: companyName ? companyName : "",
        api_url_base_path: normalizedSiteUrl,
        client_id: clientId ? clientId.trim() : "",
        client_secret: clientSecret ? clientSecret.trim() : "",
        erp_company: erpCompany ? erpCompany.trim() : "",
        userId: userid,
        status: "A",
      };
    } else {
      erpData = {
        erpLinkId: erpLinkId,
        userId: userid,
        companyId: companyId,
        erp: selectedERP,
        company: companyName ? companyName : "",
        connection_type: "OAuth",
        OauthUrl: oAuthUrl ? oAuthUrl : "",
        api_url_base_path: apiBaseUrl ? apiBaseUrl : "",
        tentId: tentId ? tentId : "",
        client_id: clientId ? clientId : "",
        client_secret: clientSecret ? clientSecret : "",
        scope: scope ? scope : "",
        grant_type: "client_credentials",
        status: "A",
      };
    }

    const payload = erpData;
    axios
      .post(domain + "/api/v1/erp/edit-erp-companyconfig", payload, { headers })
      .then((resp) => {
        console.log(resp, resp.statusCode);
        if (resp.data.statusCode === 0) {
          setSuccessMessage(resp.data.message);
          setDisplayModal(true);
          setSuccessModal(true);
          showERPConnections(companyId);
          // setErpConnectionInfo(false);
          setLinkStatus({ msbc: false, tally_prime: false });
        } else {
          setErrorMessage(resp.data.message);
          setDisplayModal(true);
          setErrorModal(true);
          // showERPConnections(companyInfo);
          // setErpConnectionInfo(false);
          // setLinkStatus({msbc:false,tally_prime:false})
        }
      })
      .catch((error) => {
        console.error("Error in updating ERP Link:", error);
      });
  };


  const [companyNameBreadCrum, setcompanyNameBreadCrum] = useState('');  // company name

  return (
    <div className={`${companyCss.subContainer}`}>
      <CompanyEditSideMenu
        activeTab={"ERP Linking"} 
        companyID={companyID} 
        companyDataCheck={true}
        setcompanyName={setcompanyNameBreadCrum}
      />
      <div className="w-100">
        <div className={companyCss.subContainer__} style={{ padding: "0px 15px", height: "98vh" }}>
          <Breadcrumb
            addCls={commoncss.bgClr1}
            items={breadcrumbItems}
            headerActions={<></>}
            p0={true}
          />
          <div className="connections-wrapper" style={{ borderRadius:"20px"}}>
            {linkErpBtn && (
              // <div className="erp-info-div">
              <div className={companyCss.emptyERPState}>
                <ERPLink width={120}/>
                <span>
                  No ERP has been linked yet, Click on the button <br /> below to link an ERP 
                </span>
                <Button
                  icon={<PlusIcon />}
                  btnColor={buttoncss.primary}
                  label="Add New ERP"
                  onClick={() => {
                    setAddERPModal(true);
                    setDisplayModal(true);
                  }}
                  class_={"add-erp-btn"}
                />

                {/* <span className="companyname-header primaryColor">
                  No ERP Linked
                </span>
                <br/>
                <Button
                  btnColor={buttoncss.primary}
                  label="Add New ERP"
                  onClick={() => {
                    setAddERPModal(true);
                    setDisplayModal(true);
                  }}
                  class_={"add-erp-btn"}
                /> */}
              </div>
              // </div>
            )}
            {/* {linkErpBtn && (
                
              )} */}
            {erpConnectionInfo && (
              <div className="edit-company-content info-content">
                {/* <div className="company-header">
                    <span className="companyname-header">
                      <LeftIcon
                        className="close-erp-info clickable"
                        onClick={() => {
                          setErpConnectionInfo(false);
                        }}
                      />
                      {companyInfo.company_name}
                      
                    </span>
                    <hr className="hr-brcolor" />
                  </div> */}
                {/* {linkErpBtn && (
                <Button
                  btnColor={buttoncss.primary}
                  label="Add New ERP"
                  onClick={() => {
                    setAddERPModal(true);
                    setDisplayModal(true);
                  }}
                  class_={"add-erp-btn"}
                />
              )}
              {linkErpBtn && (
                // <div className="erp-info-div">
                <span className="companyname-header primaryColor">
                  No ERP Linked
                </span>
                // </div>
              )} */}

                {companyErp && companyErp === "DynamicBC" && (
                  <>
                    <Tabs
                      class_={"erp-tabs"}
                      tabs={erpTabs}
                      activeTab={"MSBC"}
                      setActiveTab={setActiveTab}
                    />
                    <div className="erp-info-div">
                      <InputGroup
                        inputs={[
                          <>
                            <InputGroup
                              label="Linked ERP"
                              inputs={[
                                <>
                                  <Dropdown
                                    // label="Linked ERP"
                                    options={erps}
                                    onSelect={(selected) => {
                                      setSelectedERP(selected.value);
                                      setCompanyErp(selected.value);
                                    }}
                                    placeHolder={"Select ERP"}
                                    selected={{
                                      label: "MSBC",
                                      value: "msbc",
                                    }}
                                  />
                                </>,
                              ]}
                            />
                          </>,
                          <>
                            <InputGroup
                              label="Company Name"
                              inputs={[
                                <>
                                  <input
                                    type="text"
                                    value={companyName}
                                    onChange={(e) =>
                                      setCompanyName(e.target.value)
                                    }
                                  />
                                </>,
                              ]}
                            />
                          </>,
                        ]}
                      />

                      <InputGroup
                        inputs={[
                          <>
                            <InputGroup
                              label="Connection Type"
                              inputs={[
                                <>
                                  <Dropdown
                                    // label="Connection Type"
                                    options={[
                                      {
                                        label: "OAuth",
                                        value: "OAuth",
                                      },
                                    ].map((connectiontype) => ({
                                      label: connectiontype.label,
                                      value: connectiontype.value,
                                    }))}
                                    onSelect={(value) =>
                                      setConnectionType(value)
                                    }
                                    placeHolder={"Connection Type"}
                                    selected={{
                                      label: connectionType,
                                      value: connectionType,
                                    }}
                                  />
                                </>,
                              ]}
                            />
                          </>,
                          <>
                            <InputGroup
                              label="Grant Type"
                              inputs={[
                                <>
                                  <Dropdown
                                    // label="Grant Type"
                                    options={[
                                      {
                                        label: "client_credentials",
                                        value: "client_credentials",
                                      },
                                    ].map((connectiontype) => ({
                                      label: connectiontype.label,
                                      value: connectiontype.value,
                                    }))}
                                    onSelect={(value) => setGrantType(value)}
                                    placeHolder={"Grant Type"}
                                    selected={{
                                      label: grantType,
                                      value: grantType,
                                    }}
                                  />
                                </>,
                              ]}
                            />
                          </>,
                        ]}
                      />

                      <InputGroup
                        inputs={[
                          <>
                            <InputGroup
                              label="OAuth URL"
                              inputs={[
                                <>
                                  <textarea
                                    value={oAuthUrl}
                                    onChange={(e) =>
                                      setOAuthUrl(e.target.value)
                                    }
                                    rows={2}
                                  />
                                </>,
                              ]}
                            />
                          </>,
                          <>
                            <InputGroup
                              label="API Base URL"
                              inputs={[
                                <>
                                  <textarea
                                    value={apiBaseUrl}
                                    onChange={(e) =>
                                      setApiBaseUrl(e.target.value)
                                    }
                                    rows={2}
                                  />
                                </>,
                              ]}
                            />
                          </>,
                        ]}
                      />

                      <InputGroup
                        inputs={[
                          <>
                            <InputGroup
                              label="Tenent ID"
                              inputs={[
                                <>
                                  <input
                                    type="text"
                                    value={tentId}
                                    onChange={(e) => setTentId(e.target.value)}
                                  />
                                </>,
                              ]}
                            />
                          </>,
                          <>
                            <InputGroup
                              label="Client ID"
                              inputs={[
                                <>
                                  <input
                                    type="text"
                                    value={clientId}
                                    onChange={(e) =>
                                      setClientId(e.target.value)
                                    }
                                  />
                                </>,
                              ]}
                            />
                          </>,
                        ]}
                      />
                      <InputGroup
                        inputs={[
                          <>
                            <InputGroup
                              label="Client Secret"
                              inputs={[
                                <>
                                  <input
                                    type="text"
                                    value={clientSecret}
                                    onChange={(e) =>
                                      setClientSecret(e.target.value)
                                    }
                                  />
                                </>,
                              ]}
                            />
                          </>,
                          <>
                            <InputGroup
                              label="Scope"
                              inputs={[
                                <>
                                  <input
                                    type="text"
                                    value={scope}
                                    onChange={(e) => setScope(e.target.value)}
                                  />
                                </>,
                              ]}
                            />
                          </>,
                        ]}
                      />

                      <ToggleButton
                        class_={`m_tb_20 ${commoncss.displayNone}`}
                        label=""
                        id="msbc"
                        value={linkStatus.msbc}
                        onToggle={handleLinkStatus}
                      />
                      <Button
                        btnColor={buttoncss.primary}
                        label="Save"
                        onClick={() => {
                          updateErpConfigData();
                        }}
                        class_={"save-creds-btn"}
                      />
                    </div>
                  </>
                )}
                {companyErp && companyErp === "tallyPrime" && (
                  <>
                    <Tabs
                      class_={"erp-tabs"}
                      tabs={erpTabs}
                      activeTab={"Tally Prime"}
                      setActiveTab={setActiveTab}
                    />
                    <div className="erp-info-div">
                      <InputGroup
                        inputs={[
                          <>
                            <InputGroup
                              label="Linked ERP"
                              inputs={[
                                <>
                                  <Dropdown
                                    // label="Linked ERP"
                                    options={erps}
                                    onSelect={(selected) => {
                                      setSelectedERP(selected.value);
                                      setCompanyErp(selected.value);
                                    }}
                                    selected={{
                                      label: "Tally Prime",
                                      value: "tally_prime",
                                    }}
                                    placeHolder={"Select ERP"}
                                  />
                                </>,
                              ]}
                            />
                          </>,
                          <>
                            <InputGroup
                              label="Company Name"
                              inputs={[
                                <>
                                  <input
                                    type="text"
                                    value={companyName}
                                    onChange={(e) =>
                                      setCompanyName(e.target.value)
                                    }
                                  />
                                </>,
                              ]}
                            />
                          </>,
                        ]}
                      />

                      <InputGroup
                        inputs={[
                          <>
                            <InputGroup
                              inputs={[
                                <>
                                  <InputGroup
                                    label="API Base URL"
                                    inputs={[
                                      <>
                                        <textarea
                                          value={apiBaseUrl}
                                          onChange={(e) =>
                                            setApiBaseUrl(e.target.value)
                                          }
                                          rows={4}
                                        />
                                      </>,
                                    ]}
                                  />
                                </>,
                              ]}
                            />
                          </>,
                          <></>,
                        ]}
                      />

                      <ToggleButton
                        class_={`m_tb_20 ${commoncss.displayNone}`}
                        label=""
                        id="tally_prime"
                        value={linkStatus.tally_prime}
                        onToggle={handleLinkStatus}
                      />
                      <Button
                        btnColor={buttoncss.primary}
                        label="Save"
                        onClick={() => {
                          updateErpConfigData();
                        }}
                        class_={"save-creds-btn"}
                      />
                    </div>
                  </>
                )}
                {companyErp && companyErp === "erpnext" && (
                  <>
                    <Tabs
                      class_={"erp-tabs"}
                      tabs={erpTabs}
                      activeTab={"ERPNext"}
                      setActiveTab={setActiveTab}
                    />
                    <div className="erp-info-div">
                      <InputGroup
                        inputs={[
                          <>
                            <InputGroup
                              label="Linked ERP"
                              inputs={[
                                <>
                                  <Dropdown
                                    options={erps}
                                    onSelect={(selected) => {
                                      setSelectedERP(selected.value);
                                      setCompanyErp(selected.value);
                                    }}
                                    selected={{
                                      label: "ERPNext",
                                      value: "erpnext",
                                    }}
                                    placeHolder={"Select ERP"}
                                  />
                                </>,
                              ]}
                            />
                          </>,
                          <>
                            <InputGroup
                              label="Site URL"
                              inputs={[
                                <>
                                  <input
                                    type="text"
                                    placeholder="e.g. https://your-site.frappe.cloud"
                                    value={apiBaseUrl}
                                    onChange={(e) =>
                                      setApiBaseUrl(e.target.value)
                                    }
                                  />
                                </>,
                              ]}
                            />
                          </>,
                        ]}
                      />

                      <InputGroup
                        inputs={[
                          <>
                            <InputGroup
                              label="API Key"
                              inputs={[
                                <>
                                  <input
                                    type="text"
                                    placeholder="Enter API Key"
                                    value={clientId}
                                    onChange={(e) =>
                                      setClientId(e.target.value)
                                    }
                                  />
                                </>,
                              ]}
                            />
                          </>,
                          <>
                            <InputGroup
                              label="API Secret"
                                inputs={[
                                  <div 
                                    style={{ position: "relative", width: "100%", display: "flex", alignItems: "center" }}
                                    onMouseEnter={() => setIsHovered(true)}
                                    onMouseLeave={() => setIsHovered(false)}
                                  >
                                    <input
                                      type={showSecret ? "text" : "password"}
                                      placeholder="Enter API Secret"
                                      value={clientSecret}
                                      onChange={(e) =>
                                        setClientSecret(e.target.value)
                                      }
                                      style={{ width: "100%", paddingRight: "30px" }}
                                    />
                                    <i 
                                      className={showSecret ? "fas fa-eye" : "far fa-eye-slash"} 
                                      onClick={() => setShowSecret(!showSecret)}
                                      style={{ 
                                        position: "absolute", 
                                        right: "10px", 
                                        cursor: "pointer", 
                                        color: "#6c757d", 
                                        fontSize: "13px",
                                        opacity: isHovered ? 1 : 0,
                                        pointerEvents: isHovered ? "auto" : "none",
                                        transition: "opacity 0.15s ease-in-out"
                                      }}
                                    ></i>
                                  </div>,
                                ]}
                            />
                          </>,
                        ]}
                      />

                      <InputGroup
                        inputs={[
                          <>
                            <InputGroup
                              label="ERPNext Company"
                              inputs={[
                                <>
                                  <input
                                    type="text"
                                    placeholder="Enter ERPNext Company name"
                                    value={erpCompany}
                                    onChange={(e) =>
                                      setErpCompany(e.target.value)
                                    }
                                  />
                                </>,
                              ]}
                            />
                          </>,
                          <></>,
                        ]}
                      />

                      <ToggleButton
                        class_={`m_tb_20 ${commoncss.displayNone}`}
                        label=""
                        id="erpnext"
                        value={linkStatus.erpnext}
                        onToggle={handleLinkStatus}
                      />
                      <Button
                        btnColor={buttoncss.primary}
                        label="Save"
                        onClick={() => {
                          updateErpConfigData();
                        }}
                        class_={"save-creds-btn"}
                      />
                    </div>
                  </>
                )}
              </div>
            )}
            {addERPModal && displayModal && (
              <AddERPConfigModal
                erps={erps}
                handleClose={handleClose}
                setAddERP={setAddERPModal}
                erpConfigData={erpConfigData}
                company={selectedCompanyName || companyName}
                companyId={companyId}
              />
            )}
            {successModal && displayModal && (
              <SuccessModal
                handleClose={handleClose}
                setSuccessModal={setSuccessModal}
                setSuccessMessage={setSuccessMessage}
                successMessage={successMessage}
              />
            )}

            {errorModal && displayModal && (
              <ErrorModal
                // handleClose={}
                setErrorModal={setErrorModal}
                setErrorMessage={setErrorMessage}
                errorMessage={errorMessage}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
